import React from "react";
import Loading from "@streeteasy/design-system/deprecated/Loading";
import { bool, string } from "prop-types";

import * as S from "./styled";

const FormLoading = ({ className, isModal }) => (
  <S.LoadingContactBox className={className} hasPadding isModal={isModal}>
    Loading Contact Form...
    <Loading />
  </S.LoadingContactBox>
);

FormLoading.propTypes = {
  className: string,
  isModal: bool
};

FormLoading.defaultProps = {
  className: "",
  isModal: false
};

export default FormLoading;
